var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { className } from '@empori/util';
import * as React from 'react';
import { PageListItemType } from '../types';
import { ServiceItemContent } from './serviceItemContent';
function NewsArticle(props) {
    var getDesc = function () {
        if (props.item.description && props.item.description.length > 100) {
            return props.item.description.substring(0, 100) + '...';
        }
        return props.item.description;
    };
    var handleTagClick = function (tag, event) {
        event.preventDefault();
        props.setTag(tag);
    };
    var date = new Date(props.item.publishedDate);
    var dateString = date
        .toLocaleDateString('sv-SE', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    }).replace('.', '');
    return (React.createElement("a", { className: className('basic-grid-item element-flex three', { viewing: props.itemToggled }), href: props.item.linkUrl, title: props.item.title },
        React.createElement("div", { className: 'basic-grid-image', style: { backgroundImage: "url(".concat(props.item.imgPath, ")") } }, !props.item.imgPath && React.createElement("i", { className: 'fa-regular fa-newspaper' })),
        React.createElement("div", { className: 'basic-grid-info' },
            React.createElement("div", { className: 'basic-grid-icon element-flex' }, props.item.tags.map(function (tag, index) {
                return React.createElement(Tag, { key: "tag-".concat(index++), title: tag, click: handleTagClick, active: props.activeTags.includes(tag) });
            })),
            React.createElement("h3", { className: 'basic-grid-title' }, props.item.title),
            React.createElement("div", { className: 'published' },
                "Publicerat ",
                dateString),
            props.item.description && React.createElement("p", null,
                getDesc(),
                React.createElement("span", { className: 'empori-button p-c-bgc text-like' },
                    props.item.linkLabel,
                    React.createElement("i", { className: 'fa-regular fa-chevron-right' }))))));
}
function ServiceItem(props) {
    var container = React.useRef(null);
    var _a = React.useState(null), parentRect = _a[0], setParentRect = _a[1];
    var staticMargin = 20;
    var _b = React.useState(staticMargin), marginBottom = _b[0], setMarginBottom = _b[1];
    var _c = React.useState(props.item.title), title = _c[0], setNewTitle = _c[1];
    React.useEffect(function () {
        if (container.current) {
            setParentRect(container.current.getBoundingClientRect());
        }
        var onScroll = function () {
            if (container.current) {
                setParentRect(container.current.getBoundingClientRect());
            }
        };
        window.addEventListener('scroll', onScroll);
    }, [container]);
    var handleTagClick = function (tag, event) {
        event.preventDefault();
        props.setTag(tag);
    };
    var handleItemToggle = function (event) {
        props.updateUrl({ itemId: props.item.contentId });
        if (container.current) {
            setParentRect(container.current.getBoundingClientRect());
        }
    };
    React.useEffect(function () {
        // Not the best hyphenate practice. Could work just fine for now though.
        if (title && title.length > 13) {
            if (title.includes(' ')) {
                return;
            }
            setNewTitle("".concat(title.slice(0, 13), "&shy;").concat(title.slice(13)));
        }
        // Not the best way to close an item by checking classes like this, but it could also work fine for now.
        var closeContentWindow = function (event) {
            var clickedEl = event.target;
            if (container.current &&
                clickedEl.classList.contains('row-parent') ||
                clickedEl.classList.contains('filter-page-list') ||
                clickedEl.classList.contains('basic-grid-content')) {
                props.updateUrl({ itemId: 0 });
                setParentRect(null);
            }
        };
        window.addEventListener('click', closeContentWindow);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { onClick: handleItemToggle, ref: container, className: className('basic-grid-item element-flex', { viewing: props.itemToggled, blocked: props.itemBlocked }), style: { marginBottom: marginBottom } },
            React.createElement("div", { className: 'basic-grid-info' },
                React.createElement("div", { className: 'basic-grid-icon element-flex' }, props.item.tags.map(function (tag, index) {
                    return React.createElement(Tag, { key: "tag-".concat(index++), title: tag, click: handleTagClick, active: props.activeTags.includes(tag) });
                })),
                React.createElement("h3", { className: 'basic-grid-title', dangerouslySetInnerHTML: { __html: title } }),
                props.item.description && React.createElement("p", null, props.item.description),
                React.createElement("div", { className: 'button-container' },
                    React.createElement("span", { className: 'empori-button p-c-bgc text-like', title: props.item.title }, props.itemToggled
                        ? React.createElement("div", { key: 'open' },
                            "St\u00E4ng",
                            React.createElement("i", { className: 'fa-regular fa-times' }))
                        : React.createElement("div", { key: 'closed' },
                            props.item.linkLabel,
                            React.createElement("i", { className: 'fa-regular fa-chevron-right' })))))),
        props.itemToggled && parentRect &&
            React.createElement(ServiceItemContent, __assign({}, props, { parentRect: parentRect, setParentMargin: setMarginBottom, closeItem: handleItemToggle }))));
}
function Tag(_a) {
    var title = _a.title, click = _a.click, active = _a.active;
    if (!title) {
        return null;
    }
    return (React.createElement("div", { className: className('page-tag', { active: active }), onClick: function (event) { return click(title, event); } }, title));
}
export function PageItem(props) {
    if (props.item.pageType === PageListItemType.newsArticle) {
        return React.createElement(NewsArticle, __assign({}, props));
    }
    return React.createElement(ServiceItem, __assign({}, props));
}
;
